import useIsCompact from '@hooks/app/useIsCompact';
import React from 'react';
import PatientsDesktop from './patients-desktop';
import PatientsMobile from './patients-mobile';

const Patients: React.FunctionComponent = (props: any) => {
  const isCompact = useIsCompact();
  return isCompact ? <PatientsMobile {...props} /> : <PatientsDesktop {...props} />;
};

export default Patients;
